// extracted by mini-css-extract-plugin
export default {"container":"NoFaxesOverlay_container__OBrs7","overlay":"NoFaxesOverlay_overlay__x6y3K","dragActive":"NoFaxesOverlay_dragActive__KMXcY"};